import { BomDto } from "src/dtos/bom/BomDto";
import { ProductDowntimeDto } from "src/dtos/productDowntime/ProductDowntimeDto";
import { ProductOrderDto } from "src/dtos/productOrder/ProductOrderDto";
import { ProductResultDto } from "src/dtos/productResult/ProductResultDto";
import { defaultPrdInspectResultDto, PrdInspectResultDto } from "src/dtos/prdInspectResult/prdInspectResultDto";
import { WmsStockLotDto } from "src/dtos/wmsLot/wmsStockLotDto";
import { formatDate, toLocalDateTime } from "src/utils/string/stringUtil";

export interface PRD3010_R01Dto {
	productOrderHeaderDto: PRD3010_R01HeaderDto;
	productResultHeaderDto: PRD3010_R01ProductResultDto;
	wmsStockLotDtoList: PRD3010_R01LotDto[];
	bomDtoList: PRD3010_R01DetailDto[];
	prdInspectResultDtoList: PrdInspectResultDto[];
}

export interface PRD3010_R01HeaderDto extends ProductOrderDto {

	//품목 단가를 처리하기 위한 필드
	itemSpec: string;
	itemUnit: string;
	itemCost: number;

	productResultNo: string;
	productDt: string | undefined;

	productEmp: string;
	productEmpNm: string;

	warehouseCd: string;
	warehouseNm: string;
	outWarehouseCd: string; //출고창고 - detail 검색에 사용
	badWarehouseCd: string; //불량창고 - detail 검색에 사용

	logicCenter: string;
	logicCenterNm: string;
	productQty: number;
	badQty: number;
	acceptQty: number;

	itemStatus: string;

	basOrderType: string;
	basOrderNo: string;
	basOrderItemNo: string;

	/** 품목 거래처코드에 연결된 거래처명(mst_custom.custom_nm) — 라벨 customer */
	customNm: string;

}

export const defaultPRD3010_R01HeaderDto: PRD3010_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	
	productOrderNo: '',
	compCd: '',
	compNm: '',
	orderDt: formatDate(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	workProcess: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	orderQty: 0,
	orderEmp: '',
	orderEmpNm: '',
	productPlanNo: '',
	resultQty: 0,
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	closeTag: "N",
	instructions: '',
	remark: '',

	customNm: '',

	itemCost: 0,

	productResultNo: '',
	productDt: formatDate(new Date()),

	productEmp: '',
	productEmpNm: '',

	warehouseCd: '',
	warehouseNm: '',
	outWarehouseCd: '',
	badWarehouseCd: '',

	logicCenter: '',
	logicCenterNm: '',
	productQty: 0,
	badQty: 0,
	acceptQty: 0,

	itemStatus: '',

	inserted: false,
	isModified: false
}

export interface PRD3010_R01ProductResultDto extends ProductResultDto {

}

export const defaultPRD3010_R01ProductResultDto: PRD3010_R01ProductResultDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	productResultNo: '',
	compCd: '',
	compNm: '',
	productDt: formatDate(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	itemCd: '',
	itemStatus: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	productOrderNo: '',
	orderQty: 0,
	productEmp: '',
	productEmpNm: '',
	workStartDt: toLocalDateTime(new Date()),
	workEndDt: undefined,
	productQty: 0,
	badQty: 0,
	acceptQty: 0,
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	kpiYn: '',
	inspectQty: 0,
	inspectYn: 'N',

	inserted: false,
	isModified: false,
}


export interface PRD3010_R01LotDto extends WmsStockLotDto {

}

export const defaultPRD3010_R01LotDto: PRD3010_R01LotDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	warehouseCd: '',
	warehouseNm: '',
	lotNo: '',
	purchaseLotNo: '',
	lotCreateDt: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	itemStatus: '',
	lotQty: 0,
	transportNo: '',
	itemNo: '',
	remark: '',

	inserted: false,
	isModified: false,
}	

export interface PRD3010_R01DetailDto extends BomDto {

	warehouseCd: string;
	warehouseNm: string;
	logicCenter: string;
	lotNo: string;
	itemStatus: string;
	itemNm: string;
	itemUnit: string;
	transportNo: string;
	itemNo: string;
	lotQty: number;
	bomUsingQty: number;
	transportQty: number;
	
}

export const defaultPRD3010_R01DetailDto: PRD3010_R01DetailDto = {

	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	prntItemcd: '',
	prntItemnm: '',
	childItemcd: '',
	childItemnm: '',
	itemSpec: '',
	bomSeq: 0,
	bomUseyn: '',
	bomUpdateNo: '',
	prntItemQty: 0,
	prntItemUnit: '',
	childItemUsage: 0,
	childItemUnit: '',
	fixLossqty: 0,
	materialIntype: 'PURCHASE',
	lossPercent: 0,
	remark: '',

	warehouseCd: '',
	warehouseNm: '',
	logicCenter: '',
	lotNo: '',
	itemStatus: '',
	itemNm: '',
	itemUnit: '',
	transportNo: '',
	itemNo: '',
	lotQty: 0,
	bomUsingQty: 0,
	transportQty: 0,

	inserted: false,
	isModified: false,
}


export interface PRD3010_R01InspectDto extends PrdInspectResultDto {

}

export const defaultPRD3010_R01InspectDto: PRD3010_R01InspectDto = {
	...defaultPrdInspectResultDto,
};

export interface PRD3010_R01DowntimeDto extends ProductDowntimeDto {

}

export const defaultPRD3010_R01DowntimeDto: PRD3010_R01DowntimeDto = {

	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	productResultNo: '',
	downtimeNo: '',
	compCd: '',
	compNm: '',
	productDt: formatDate(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	productEmp: '',
	productEmpNm: '',
	fromTime: toLocalDateTime(new Date()),
	toTime: toLocalDateTime(new Date()),
	downtimeCase: '',
	remark: '',

	inserted: false,
	isModified: false,
}
